// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/work_department.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/work_department.proto.
 */
export const file_general_work_department: GenFile = /*@__PURE__*/
  fileDesc("Ch1nZW5lcmFsL3dvcmtfZGVwYXJ0bWVudC5wcm90bxIOcHJvdG9zLmdlbmVyYWwq4AQKDldvcmtEZXBhcnRtZW50EhsKF1dPUktfREVQQVJUTUVOVF9VTktOT1dOEAASIwofV09SS19ERVBBUlRNRU5UX0FOSU1BTF9XUkFOR0xFUhABEhoKFldPUktfREVQQVJUTUVOVF9DQU1FUkEQAhIcChhXT1JLX0RFUEFSVE1FTlRfQ09TVFVNRVMQAxIiCh5XT1JLX0RFUEFSVE1FTlRfQVJUX0RFUEFSVE1FTlQQBBIdChlXT1JLX0RFUEFSVE1FTlRfRElSRUNUSU9OEAUSIwofV09SS19ERVBBUlRNRU5UX1BPU1RfUFJPRFVDVElPThAGEiAKHFdPUktfREVQQVJUTUVOVF9HUklQX0VMRUNUUk8QBxIkCiBXT1JLX0RFUEFSVE1FTlRfSEFJUl9BTkRfTUFLRV9VUBAIEiUKIVdPUktfREVQQVJUTUVOVF9IRUFMVEhfQU5EX1NBRkVUWRAJEh4KGldPUktfREVQQVJUTUVOVF9QUk9EVUNUSU9OEAoSGQoVV09SS19ERVBBUlRNRU5UX1NPVU5EEAsSIwofV09SS19ERVBBUlRNRU5UX1NQRUNJQUxfRUZGRUNUUxAMEh4KGldPUktfREVQQVJUTUVOVF9URUxFVklTSU9OEA0SHgoaV09SS19ERVBBUlRNRU5UX0FDQ09VTlRJTkcQDhIkCiBXT1JLX0RFUEFSVE1FTlRfQ09NUEFOWV9GVU5DVElPThAPEhkKFVdPUktfREVQQVJUTUVOVF9NVVNJQxAQEhoKFldPUktfREVQQVJUTUVOVF9BQ1RJTkcQEWIGcHJvdG8z");

/**
 * @generated from enum protos.general.WorkDepartment
 */
export enum WorkDepartment {
  /**
   * @generated from enum value: WORK_DEPARTMENT_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: WORK_DEPARTMENT_ANIMAL_WRANGLER = 1;
   */
  ANIMAL_WRANGLER = 1,

  /**
   * @generated from enum value: WORK_DEPARTMENT_CAMERA = 2;
   */
  CAMERA = 2,

  /**
   * @generated from enum value: WORK_DEPARTMENT_COSTUMES = 3;
   */
  COSTUMES = 3,

  /**
   * @generated from enum value: WORK_DEPARTMENT_ART_DEPARTMENT = 4;
   */
  ART_DEPARTMENT = 4,

  /**
   * @generated from enum value: WORK_DEPARTMENT_DIRECTION = 5;
   */
  DIRECTION = 5,

  /**
   * @generated from enum value: WORK_DEPARTMENT_POST_PRODUCTION = 6;
   */
  POST_PRODUCTION = 6,

  /**
   * @generated from enum value: WORK_DEPARTMENT_GRIP_ELECTRO = 7;
   */
  GRIP_ELECTRO = 7,

  /**
   * @generated from enum value: WORK_DEPARTMENT_HAIR_AND_MAKE_UP = 8;
   */
  HAIR_AND_MAKE_UP = 8,

  /**
   * @generated from enum value: WORK_DEPARTMENT_HEALTH_AND_SAFETY = 9;
   */
  HEALTH_AND_SAFETY = 9,

  /**
   * @generated from enum value: WORK_DEPARTMENT_PRODUCTION = 10;
   */
  PRODUCTION = 10,

  /**
   * @generated from enum value: WORK_DEPARTMENT_SOUND = 11;
   */
  SOUND = 11,

  /**
   * @generated from enum value: WORK_DEPARTMENT_SPECIAL_EFFECTS = 12;
   */
  SPECIAL_EFFECTS = 12,

  /**
   * @generated from enum value: WORK_DEPARTMENT_TELEVISION = 13;
   */
  TELEVISION = 13,

  /**
   * @generated from enum value: WORK_DEPARTMENT_ACCOUNTING = 14;
   */
  ACCOUNTING = 14,

  /**
   * @generated from enum value: WORK_DEPARTMENT_COMPANY_FUNCTION = 15;
   */
  COMPANY_FUNCTION = 15,

  /**
   * @generated from enum value: WORK_DEPARTMENT_MUSIC = 16;
   */
  MUSIC = 16,

  /**
   * @generated from enum value: WORK_DEPARTMENT_ACTING = 17;
   */
  ACTING = 17,
}

/**
 * Describes the enum protos.general.WorkDepartment.
 */
export const WorkDepartmentSchema: GenEnum<WorkDepartment> = /*@__PURE__*/
  enumDesc(file_general_work_department, 0);

